//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';

import ThresholdStatus from '@catalog-ingestion/components/review-panel/ThresholdStatus';

export const ThresholdPassedDescription = () => {
  return (
    <ThresholdStatus
      iconName='circle-checkmark'
      iconClass='cu-color-success'
      message='Your catalog looks great!'
      information='Your catalog exceeded basic quality standards - we recommend connecting your catalog now.
      To fix catalog errors, vist the "Catalog" page after your catalog has been connected.'
    />
  );
};

export default ThresholdPassedDescription;
